module.exports = __webpack_public_path__ + "img/sample17.de235339.jpg";